import type React from 'react';
import { logoForHeader } from '../../../images/index.js';

type LogoProps = {
  readonly className?: string;
  readonly width?: string;
  readonly height?: string;
};

export const TakeshapeLogoForHeader: React.FC<LogoProps> = ({ className, width, height }: LogoProps) => {
  if (logoForHeader) {
    return <img className={className} width={width} height={height} src={logoForHeader} />;
  }

  return null;
};
